import createAction from 'loankeeper-common/helpers/createAction'

import { actions } from '../constants'

export const fetchFile = (args, callback) => createAction(actions.FETCH_FILE, args, { callback })

export const fetchFileSuccess = (src, contentType) => createAction(actions.FETCH_FILE_SUCCESS, { src, contentType })

export const fetchFileFailure = (error) => createAction(actions.FETCH_FILE_FAILURE, { error })
